import type { StudyAnalysis } from './studyAnalysisApi';

export type StudyExecutionPhase =
  | 'upload'
  | 'queued'
  | 'reading'
  | 'notes'
  | 'knowledge'
  | 'practice';
export const STUDY_EXECUTION_LABELS: Record<StudyExecutionPhase, string> = {
  upload: 'Saving your pages',
  queued: 'Waiting for a turn',
  reading: 'Reading your pages',
  notes: 'Putting your notes together',
  knowledge: 'Connecting the learning points',
  practice: 'Making practice questions',
};

/** No timers or inferred practice stage: only the owned analysis read model drives this. */
export function analysisExecutionPhase(
  analysis: Pick<StudyAnalysis, 'status' | 'delivery_stage' | 'progress'>,
): StudyExecutionPhase {
  if (analysis.status === 'queued') return 'queued';
  if (
    analysis.delivery_stage === 'notes' ||
    analysis.delivery_stage === 'knowledge' ||
    analysis.delivery_stage === 'reading'
  )
    return analysis.delivery_stage;
  // Legacy tasks have no delivery stage. Completed/failed OCR counts are not
  // evidence that note generation started, so keep the wording conservative.
  return 'reading';
}
